import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Passare ore ogni settimana a pianificare gli allenamenti da zero.', 'Rimanere senza attività e ripetere sempre gli stessi esercizi.', 'Non sapere come strutturare un anno intero di progressione tecnica.', 'Faticare a mantenere i giocatori coinvolti e motivati durante la seduta.', 'Non avere un sistema per valutare lo sviluppo e comunicare i progressi.', 'Sentirti impreparato prima di entrare in palestra.', 'Arrivare all’allenamento senza un piano d’attacco chiaro.', 'Cercare costantemente online nuovi giochi e drill dinamici.'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-180">
      <div className="mx-auto max-w-4xl text-center" data-id="element-181">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-182">
          La realtà dell’allenamento
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-183">
          Se alleni a pallavolo, probabilmente stai affrontando almeno uno di
          questi problemi.
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-184">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-4" data-id="element-185">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-186" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-187">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-emerald-300 sm:text-4xl" data-id="element-188">
          Quanti altri allenamenti vuoi continuare a improvvisare?
        </p>
      </div>
    </section>;
}